<section #svgAreaWrapper class="section-container d-flex flex-column flex-md-row">
  <div class="order-1 col-12 offset-md-1 col-md-7">
    <div class="card">
      <div class="d-flex justify-content-between">
        <h2 class="text-lg text-md-xl mb-4 text-capitalize">{{ 'seats_selection.title' | transloco }}:</h2>
        <span class="text-base text-light" *ngIf="maxSeats$ | async as maxSeats"
          >{{
            maxSeats === 1
              ? ('seats_selection.seats_limit_hint' | transloco)
              : ('seats_selection.seats_limit_hint_plural' | transloco: { number: maxSeats })
          }}
        </span>
      </div>

      <div
        *ngIf="(seatCustomColors$ | async) && (areaSVG$ | async) as areaSVG"
        class="svg-container"
        (click)="handleSeatClick($event)"
      >
        <!--      <div class="svg-overlay" *ngIf="reserving$ | async">
          <span class="loader"></span>
        </div> -->
        <figure class="svg-figure" [innerHTML]="areaSVG"></figure>
        <span class="tooltip" id="max-seats-tooltip" *ngIf="maxSeats$ | async as maxSeats">
          {{
            maxSeats === 1
              ? ('seats_selection.max_seats_tooltip_hint' | transloco)
              : ('seats_selection.max_seats_tooltip_hint_plural' | transloco: { number: maxSeats })
          }}
        </span>
        <span class="tooltip" id="gap-not-allowed-tooltip">{{
          'seats_selection.gap_not_allowed_tooltip_hint' | transloco
        }}</span>
      </div>

      <div *ngIf="loading" class="seats-placeholder">
        <mat-spinner class="spinner-primary" [diameter]="30"></mat-spinner>
      </div>

      <plys-seats-legenda></plys-seats-legenda>
    </div>
  </div>
  <div class="order-0 col-12 order-md-1 col-md-3">
    <plys-movie-widget></plys-movie-widget>
    <div class="d-none d-md-block">
      <plys-cart-preview [displaySeatsOnly]="displaySeatsOnly"></plys-cart-preview>
    </div>
  </div>
</section>

<footer class="footer d-none d-md-flex">
  <div class="footer-action-left">
    <button *ngIf="(isFirstStep$ | async) !== true" class="btn btn-secondary" plysGoBack>
      {{ 'global.back' | transloco }}
    </button>
  </div>
  <div class="d-flex align-items-center footer-action-right">
    <button class="btn btn-primary btn-lg" (click)="handleContinueClick()" [disabled]="!isStepValid">
      {{ 'global.continue' | transloco }}
    </button>
  </div>
</footer>
<plys-mobile-cart-footer>
  <button *ngIf="(isFirstStep$ | async) !== true" cartFooterBack class="btn btn-secondary" plysGoBack>
    {{ 'global.back' | transloco }}
  </button>
  <button cartFooterContinue class="btn btn-primary btn-lg" (click)="handleContinueClick()" [disabled]="!isStepValid">
    {{ 'global.continue' | transloco }}
  </button>
</plys-mobile-cart-footer>
